// Land/water site-kind restriction for granted site placements.
//
// Landmass ("You may play a land site") and Overflow ("You may play a
// water site") grant a free site placement (GRANT_SITE_PLACEMENT) that
// is narrowed to one kind. Per codex "Phrases with Subtle Meanings":
// "Water site (opposite of land site)." A site with at least one water
// affinity is a water site, otherwise it's a land site (codex Rubble:
// "because it has no water affinity, it is a land site").
//
// Classification is by EFFECTIVE water threshold of the candidate card
// in hand (printed water + Flooded floor), so a printed-dry site that
// somehow carries Flooded still counts as water. Pure. Reads the
// live card instance + its catalog row only.

import { effectiveSiteThresholds } from '../../core/regions';

/**
 * 'water' if the site card provides any water affinity, else 'land'.
 * @param {object} card     live site instance
 * @param {object} fullCard catalog row
 */
export function siteCardKind(card, fullCard) {
  return effectiveSiteThresholds(card, fullCard).water > 0 ? 'water' : 'land';
}

/**
 * True if the site card may be played under a grant carrying
 * `restriction`. No restriction (null/undefined) accepts any site.
 * @param {object} card        live site instance
 * @param {object} fullCard    catalog row
 * @param {'land'|'water'|null} restriction
 */
export function siteMatchesRestriction(card, fullCard, restriction) {
  if (!restriction) return true;
  return siteCardKind(card, fullCard) === restriction;
}
